import { createWrapper } from '../../fhir-react/base';

export const DocumentReferenceWrapper = createWrapper('DocumentReference', () => ({}));
export type WrappedDocumentReference = ReturnType<typeof DocumentReferenceWrapper>;
